import { VisitRequestWorkflowStep } from '@/types/graphql';
import { VisitRequestTableRowFragment } from 'src/components/bulkQueue/tables/queries.gql.types';

import { getVisitSortDate } from '../../queues/helpers';
import { deriveSortName } from '../../tables/utils';
import { OrderVisitColumns } from '../../unifiedVisits/columns';
import { getUnifiedStateIndex } from '../../unifiedVisits/utils';
import { VisitColumns } from '../../visits/tables/columns';

export namespace VisitRequestColumns {
    export const createCliniciansSortKey = (
        appointments: { clinician: { firstName: string } | null }[],
    ) => {
        return deriveSortName({
            objs: appointments,
            getKey: (appointment) => appointment.clinician?.firstName,
        });
    };

    export const createUnifiedStateIndex = (workflowStep: VisitRequestWorkflowStep) => {
        return getUnifiedStateIndex({
            workflowStep,
        });
    };
}

export interface ISortableVisitRequestTableRow extends VisitRequestTableRowFragment {
    sortDate: Date | null;
    cliniciansSortKey: string;
    sortPriority: number;
    sortStateIndex: number;
    sortServicesName: string;
    orderSortKey: number;
    link: string;
}

export function visitRequestToSortableRow(
    visitRequest: VisitRequestTableRowFragment,
): ISortableVisitRequestTableRow {
    return {
        ...visitRequest,
        sortStateIndex: VisitRequestColumns.createUnifiedStateIndex(visitRequest.workflowStep),
        sortDate: getVisitSortDate({
            ...visitRequest,
            fulfillmentWindow: visitRequest.fulfillmentWindow,
        }),
        cliniciansSortKey: VisitColumns.createCliniciansSortKey(visitRequest.appointments),
        sortPriority: VisitColumns.createPrioritySortIndex(visitRequest.priority),
        sortServicesName: VisitColumns.createServicesSortKey(visitRequest.appointments),
        orderSortKey: OrderVisitColumns.createOrderSortKey(visitRequest.order),
        link: `/visit-requests/${visitRequest.id}`,
    };
}
